const selectReportsReducer = state => state.reports;

export const selectActiveOrganizations = state => selectReportsReducer(state).activeOrganizations;

export const selectDefaultStatus = state => selectReportsReducer(state).default;
